import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { PDFsService } from '../pdfs.service';
import { TinymceComponent } from 'angular2-tinymce';
import { AuthService } from '../../../core/auth.service';
import * as _ from 'lodash';
import { AppService } from '../../../app.service';
import { Subscription } from 'rxjs';
import { VideosModalComponent } from '../../video/modals/videos-modal.component';
import { VideosService } from '../../video/videos.service';

@Component({
    templateUrl: 'pdf-modal.component.html',
    styleUrls: ['pdf-modal.component.scss'],
    providers: [
        PDFsService,
        VideosService
    ]
})

export class PdfModalComponent extends VideosModalComponent implements OnInit, AfterViewInit {
    type: string;
    url = 'pdfs';
    errorMessage = '';
    successMessage = '';
    formSubmitted: boolean = false;
    params: any = {};
    queryParams: any = {};
    id = null;
    // value null cause match api defined
    form: FormGroup;
    defaultContent: string = '';
    pdf: any = {};
    pdfURL: string;
    showRevertButton: boolean = false;
    thumbnail = '';
    isImageSaved = false;
    imageError: any;
    language: 'DE';
    subscribe: Subscription;

    noTitleTypeArr = [
        'support',
        'clinic_support',
        'help_patients',
        'help_patient',
        'help_di_overview',
        'help_di_symptom',
        'help_home',
    ];

    @ViewChild('modal', {static: false}) protected modal: ModalDirective;
    @ViewChild('pdfDescription', {static: false}) private pdfDescription: TinymceComponent;

    constructor(protected fb: FormBuilder,
                public authService: AuthService,
                public route: ActivatedRoute,
                public router: Router,
                protected appService: AppService,
                public videosService : VideosService,
                public pdfsService: PDFsService) {
        super(fb, authService, route, router, appService, videosService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.appService.isLoading = false;
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
    }

    buildForm(): void {
        this.form = this.fb.group({
            'id': [''],
            'language': [''],
            'title': ['', [Validators.required]],
            'pdf': ['', [Validators.required]],
            'description': [''],
            'show': [true],
            'picture': ['']
        });
    }

    hideModal() {
        this.subscribe.unsubscribe();
        this.router.navigate([this.url],
            {
                relativeTo: this.route.parent,
                queryParams: {
                    lang: this.language
                }
            });
    }

    loadModalData() {
        this.form.controls.language.setValue(this.language);
        if (!this.params['id']) {
            return false;
        }
        this.pdfsService.read(this.params['id'], this.language)
            .subscribe(response => {
                    this.pdf = response['pdf'];

                    this.pdf['language_flag'] = '/assets/icon/flags/' + this.language.toLowerCase() + '.png';
                    this.form.controls.title.setValue(this.pdf['title']);
                    this.form.controls.description.setValue(this.pdf['description']);
                    this.thumbnail = this.pdf['picture_url'] ? this.pdf['picture_url'] : null;
                    this.pdfURL = this.pdf['pdf_url'] ? this.pdf['pdf_url'] : null;
                    this.form.controls.id.setValue(this.id);
                    this.form.controls.pdf.setValue(this.pdf['pdf']);
                    this.form.controls.picture.setValue(this.pdf['picture']);
                    this.form.controls.show.setValue(this.pdf['show']);
                }
            );
    }

    showModal() {
        this.modal.show();
    }

    /**
     * Submit update of email templates
     *
     * @param emailTranslationForm
     * @param {boolean} isValid
     */
    submit(pdfForm: any, isValid: boolean): void {
        this.formSubmitted = true;

        if (!isValid) {
            return;
        }

        this.resetErrors();
        this.appService.isLoading = true;
        this.pdfsService.save(this.id, pdfForm, this.language).subscribe(
            response => {
                this.successMessage = response['message'];
                this.appService.isLoading = false;
                setTimeout(() => {
                    this.successMessage = '';
                    this.hideModal();
                }, 1000);
            });
    }

    resetErrors() {
        if (this.errorMessage.length > 0) {
            this.errorMessage = '';
        }
    }

    thumbnailUploaded($event) {
        this.isImageSaved = true;
        this.thumbnail = $event.src;
        this.form.controls.picture.setValue($event.serverResponse.response.body.path);
        return true;
    }

    thumbnailUploading($event) {
        return true;
    }

    fileChangeEvent(fileInput: any) {
        this.imageError = null;
        if (fileInput.target.files && fileInput.target.files[0]) {
            // Size Filter Bytes (128 Mb)
            const max_size = 128000000;
            const allowed_types = ['application/pdf'];

            if (fileInput.target.files[0].size > max_size) {
                this.imageError =
                    'Maximum size allowed is ' + max_size / 1000000 + 'Mb';

                return false;
            }

            const fileType = fileInput.target.files[0].type;
            if (!_.includes(allowed_types, fileInput.target.files[0].type)) {
                this.imageError = 'Only PDF are allowed ( .pdf )';
                return false;
            }
            const reader = new FileReader();
            reader.onload = (e: any) => {
                // Get video duration
                const blob = new Blob([e.target.result], {type: fileType}),     // create a blob of buffer
                    url = (URL || webkitURL).createObjectURL(blob),       // create o-URL of blob
                    pdf = document.createElement('video');              // create video element

                pdf.preload = 'metadata';                               // preload setting
                pdf.addEventListener('loadedmetadata', function () {     // when enough data loads
                    (URL || webkitURL).revokeObjectURL(url);                // clean up
                });
                pdf.src = url;

                // create FormData
                const formData: FormData = new FormData();
                formData.append('filename', 'test');
                formData.append('blob', fileInput.target.files[0]);

                this.pdfsService.upload(formData, this.language).subscribe(
                    response => {
                        this.successMessage = response['message'];
                        this.form.controls.pdf.setValue(response['pdf']); // Only save file name
                        this.pdf.pdf = response['pdf'];
                        this.pdf.pdf_url = response['pdfURL'];
                    });
            };
            reader.readAsDataURL(fileInput.target.files[0]);
        }
    }
}
